import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StreetTypeInterface } from '../data';
import { StreetTypeProvider } from '../providers/street-type.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetStreetTypesUseCase implements UseCase<Observable<Transaction<StreetTypeInterface[]>>> {
    constructor(private streetTypeProvider: StreetTypeProvider) {}

    bind(): Observable<Transaction<StreetTypeInterface[]>> {
        return this.streetTypeProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (types) => Transaction.success(cloneDeep(types)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
